import { Component, OnInit, Input } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-standard-referral-details',
  templateUrl: './standard-referral-details.component.html',
  styleUrls: ['./standard-referral-details.component.scss']
})
export class StandardReferralDetailsComponent implements OnInit {

  @Input() object: Object;

  constructor(
    public modalRef: MDBModalRef,
    ) { }

  ngOnInit(): void {
  }

}
